Pixlee.module('Utilities', function(Utilities, App, Backbone, Marionette, $) {

    var mixinKeywords = ['beforeIncluded', 'afterIncluded'];

    var include = function(concerns) {
        var _this = this;
        for (var i = 0; i < concerns.length; i++) {
            var concern = App.request('concern', concerns[i]);
            if (concern.beforeIncluded != null) {
                concern.beforeIncluded.call(_this.prototype, _this, concern);
            }
            Cocktail.mixin(_this, _.omit(concern, mixinKeywords));
            if (concern.afterIncluded != null) {
                concern.afterIncluded.call(_this.prototype, _this, concern);
            }
        }
    };

    var modules = [{
        Marionette: ['ItemView', 'LayoutView', 'CollectionView', 'CompositeView', 'AppRouter']
    }, {
        Entities: ['Model', 'DeepModel', 'Collection', 'PaginatedCollection', 'ClientPaginatedCollection']
    }];
    _.each(modules, function(module) {
        _.each(module, function(value, key, list) {
            _.each(value, function(klass) {
                var obj = window[key] || App[key];
                obj[klass].include = include;
            });
        });
    });

});
